<template>
	<span>
		<button v-if="entity" class="linkButton sourceTooltip" v-tooltip.click="entity.description">{{entity.name}}</button>
		<span class="sourceLink" v-else>{{source}}</span>
	</span>	
</template>
<script>
	import store from '../state'

	export default {
		name: 'SourceTooltip',
		props: ['source'],
		data() {
			return {
				entity: null
			}
		},
		mounted() {
			this.update(this.source);
		},
		methods: {
			update(value) {
				if (value.startsWith('pastebin') || value.startsWith('dumpmon')) {		
					const splits = value.split(' ');

					this.entity = {
						name: splits[0],
						description: `Credentials found online at ${splits[0]} ${splits[1]}`
					};

					return;
				}
				this.entity = store.getters.getSource(value);
			}
		},
		watch: {
			//Tooltip isnt naturally reactive, so update the entity when the prop changes
			source(value) {
				this.update(value);
			}
		}	
	}
</script>


// WEBPACK FOOTER //
// src/components/SourceTooltip.vue